import { Box, Group, SegmentedControl, Select, Stack } from "@mantine/core";
import { MapSearch } from "shared/components/map/MapSearch";
import { GeoTab } from "shared/components/message/compose/geoAudience/GeoAudienceContext";
import { useGeoAudienceEditor } from "shared/components/message/compose/geoAudience/useGeoAudienceEditor";

export const GeoAudienceHeaderControls = (props: { mapId: string }) => {
    const { tab, handleTabChange, senderLayers, selectedLayerId, setSelectedLayerId } = useGeoAudienceEditor();

    return (
        <Stack>
            <SegmentedControl
                value={tab}
                onChange={(value) => handleTabChange(value as GeoTab)}
                w="fit-content"
                data={["Draw", "Predefined"]}
            />
            <Group align="flex-end">
                <Box style={{ flex: 1 }}>
                    <MapSearch mapId={props.mapId} />
                </Box>
                {tab === "Predefined" && senderLayers.length > 0 && (
                    <Select
                        placeholder="Select a layer"
                        data={senderLayers.map((layer) => ({ value: layer.id, label: layer.name }))}
                        value={selectedLayerId}
                        onChange={setSelectedLayerId}
                    />
                )}
            </Group>
        </Stack>
    );
};
